<template>
  <div class="legend-pills">
    <button 
      v-for="(item, index) in items" 
      :key="item.name"
      class="legend-pill"
      :class="{ 'legend-pill--inactive': hiddenSeries.has(index) }"
      :style="{ '--accent-color': item.color }"
      @click="$emit('toggle-series', index)"
    >
      <span class="legend-dot"></span>
      <span class="legend-text">{{ item.name }}</span>
      <span class="legend-count" v-if="showTotal">
        {{ getTotalValue(index) }}
      </span>

    </button>
  </div>
</template>

<script setup>

const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  hiddenSeries: {
    type: Set,
    default: () => new Set()
  },
  seriesData: {
    type: Array,
    default: () => []
  },
  showTotal: {
    type: Boolean,
    default: false
  }
});

defineEmits(['toggle-series']);

import { formatNumber } from '@/Modules/utils/useFormatNumber'

const getTotalValue = (index) => {
  const series = props.seriesData[index];

  if (!series) return formatNumber(0);

  if (Array.isArray(series.data)) {
    const total = series.data.reduce((sum, val) => sum + Number(val), 0);
    return formatNumber(total);
  }

  if (typeof series.value !== 'undefined') {
    return formatNumber(Number(series.value));
  }

  return formatNumber(0);
};

</script>

<style scoped>
.legend-pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.legend-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  outline: none;
}

.legend-pill:hover {
  background: #f1f5f9;
  transform: translateY(-1px);
}

.legend-pill:active {
  transform: translateY(0);
}

.legend-pill--inactive {
  opacity: 0.4;
  background: #f8fafc;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--accent-color);
  flex-shrink: 0;
}

.legend-text {
  color: #475569;
}

.legend-count {
  font-weight: 600;
  color: #1e293b;
  background: #ffffff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  min-width: 20px;
  text-align: center;
}

@media (max-width: 768px) {
  .legend-pills {
    justify-content: flex-start;
  }
}

@media (max-width: 480px) {
  .legend-pill {
    padding: 6px 10px;
    font-size: 12px;
  }
}
</style>